import React, { useEffect } from "react";
import { animateScroll as scroll } from "react-scroll";

import AboutInfo from "./AboutInfo/AboutInfo";

import cl from "./About.module.css";

const About = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_about}>
      <AboutInfo
        shopStory={props.aboutData.story}
        cartItems={props.cartItems}
      />
    </section>
  );
};

export default About;
